import React from "react";
import { motion } from "framer-motion";

export const SpreadPicker = ({ spreads, selectedId, onSelect }) => {
  return (
    <div className="grid gap-4 sm:grid-cols-2" data-testid="spread-picker">
      {spreads.map((spread) => {
        const active = spread.id === selectedId;
        return (
          <motion.button
            key={spread.id}
            type="button"
            onClick={() => onSelect(spread.id)}
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.985 }}
            data-testid={`spread-option-${spread.id}`}
            className={`rounded-xl border p-5 text-left transition-all ${
              active
                ? "border-[#D9A441]/70 bg-[#131422] shadow-[0_0_22px_rgba(217,164,65,0.12)]"
                : "border-[#D9A441]/15 bg-[#131422]/50 hover:border-[#D9A441]/40"
            }`}
          >
            <div className="flex items-center justify-between">
              <h4 className="font-display text-xl font-medium text-[#F8F3E6]">{spread.name}</h4>
              <span className="flex items-center gap-1">
                {Array.from({ length: spread.count }).map((_, i) => (
                  <span
                    key={i}
                    className={`h-5 w-3 rounded-[3px] border ${
                      active ? "border-[#D9A441]/70 bg-[#D9A441]/20" : "border-[#A3A5B8]/40"
                    }`}
                  />
                ))}
              </span>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-[#A3A5B8]">{spread.description}</p>
          </motion.button>
        );
      })}
    </div>
  );
};
